// extracted by mini-css-extract-plugin
module.exports = {"content":"TagLine_content__irDe5","text":"TagLine_text___P8_x","button":"TagLine_button__KKRy5","cover":"TagLine_cover__87nZo"};